import { createStore } from './createStore.js';

/**
 * The set of games (PokéAPI version-group keys) the user has actually
 * played — imported a save for, or opened the dex of at least once.
 *
 * The tracking model is one unified caught record per Pokémon, so every
 * game technically shows a caught total the moment you mark anything. That
 * over-reports games you've never touched. `#/progress` uses this set to
 * lead with the games you've played and tuck the rest away.
 */
export const playedGames = createStore('pdx.playedGames', { keys: [] });

export function isPlayed(key) {
  return playedGames.get().keys.includes(key);
}

export function markPlayed(...keys) {
  const have = new Set(playedGames.get().keys);
  const add = keys.filter((k) => k && k !== 'all' && !have.has(k));
  if (!add.length) return;
  playedGames.set((s) => ({ ...s, keys: [...s.keys, ...add] }));
}

export function unmarkPlayed(key) {
  playedGames.set((s) => ({ ...s, keys: s.keys.filter((k) => k !== key) }));
}
